import { render, staticRenderFns } from "./linkedScreen.vue?vue&type=template&id=738e733c&scoped=true&"
import script from "./linkedScreen.vue?vue&type=script&lang=js&"
export * from "./linkedScreen.vue?vue&type=script&lang=js&"
import style0 from "./linkedScreen.vue?vue&type=style&index=0&id=738e733c&scoped=true&lang=css&"
import style1 from "./linkedScreen.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738e733c",
  null
  
)

export default component.exports